<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver al listado de U.I.">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="hasAddingAccess" type="button" [disabled]="actionNotAllowed" class="btn btn-outline-success" (click)="onClickAdd()" title="Añadir {{ title.singular }}">
            <i class="fa fa-file-o"></i> Añadir {{ title.singular }}</button>

        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">
    <h4 class="pt-3">Inspecciones de la Unidad de Inspección</h4>

    <app-unidad-inspeccion-header *ngIf="unidadInspeccion?.FirstRecinto" [title]="title" [formGroup]="formGroup" [unidadInspeccion]="unidadInspeccion"></app-unidad-inspeccion-header>

    <!-- Lista de inspecciones configuradas para el periodo y cumplimentadas -->
    <ng-container *ngIf="listaInspeccionPeriodo?.length > 0">
        <app-inspeccion-ui-periodo-list  [periodoEnPlazoVigente]="periodoEnPlazoVigente" [inspecciones]="inspecciones" [listaInspeccionPeriodo]="listaInspeccionPeriodo"></app-inspeccion-ui-periodo-list>
    </ng-container>

    <!-- Lista de inspecciones de la UI -->
    <app-inspeccion-ui-list *ngIf="inspecciones" [unidadInspeccion]="unidadInspeccion" [result]="inspecciones" [readonly]="readonly" [title]="title" [userData]="userData" (view)="onView($event)" (delete)="onDelete($event)"></app-inspeccion-ui-list>
</div>